import React, {useEffect, useState, useRef} from 'react';
import {actionAdmin, registerAdmin} from "../../api/web";
import $ from "../../utils/datatables";
import {GET_USERS_ROLE_URL, GET_USERS_URL, SEARCH_FARMER_URL} from "../../api";
import {capitalize} from "../../utils/capitalize";
import {Link} from "react-router-dom";
import { toast } from 'react-toastify';
import {useSelector} from "react-redux";
import moment from "moment";

let userRole = "all";

const User = (props) => {

    const token = localStorage.getItem('jwtToken');

    const [editForm, setEditForm] = useState(false);
    const [stateReady, setStateReady] = useState(false);
    const [editId, setEditId] = useState(null);

    const [roles] = useState([
        {name: "Agent", value: "agent"},
        {name: "Farmer", value: "farmer"},
        {name: "Agronomist", value: "agronomist"},
        {name: "Agro-Dealer", value: "agro-dealer"},
        {name: "Company Representatives", value: "company-rep"}
    ]);

    const [selectedRole, setSelectedRole] = useState({
        name: "All Users",
        value: "all"
    });

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const {user} = useSelector((state) => state.auth.user);

    useEffect(() => {
        var table = $('#user').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting User Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax($('.dataTables_filter input').val().length > 0 ? SEARCH_FARMER_URL($('.dataTables_filter input').val()) : userRole === "all" ? `${GET_USERS_URL}` : `${GET_USERS_ROLE_URL(userRole)}`, {
                    type: 'GET',
                    headers: {
                        Authorization: token
                    },
                    data: {
                        pageNumber: (data.length + data.start) / data.length,
                        pageSize: data.length
                    },
                    success : function(res) {
                        let result = [];

                        res.results.map((data) => {
                            result.push({
                                raw: data
                            });
                        });

                        callback({
                            recordsTotal: res.count,
                            recordsFiltered: res.count,
                            data: result
                        });
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data.username;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.first_name ? `${data.first_name} ${data.last_name}` : "not set";
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.email || "not set";
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        const primary = data.job_title === "admin"
                            ? (data.is_superuser ? "Super Admin" : capitalize(data.job_title))
                            : (data.job_title ? capitalize(data.job_title) : "");
                        const secondary = data.job_title_secondary ? capitalize(data.job_title_secondary) : "";
                        if (!primary && !secondary) return "not set";
                        return secondary ? `${primary}, ${secondary}` : primary;
                    },
                    "targets": 3
                },
                {
                    "render": function () {
                        return `<a href="#" class="nav-link view_user"><i class="fa fa-eye"></i> View</a>`;
                    },
                    "targets": 4
                }
            ]
        });

        $('#user').on('click', '.view_user', function(e) {
            e.preventDefault();
            let row = table.row($(this).closest('tr')).data();
            const u = row.raw;
            if (u && u.id) {
                props.history.push(`/user/${u.id}`);
            }
            return false;
        });

    }, [props.history]);

    useEffect(() => {
        if (!dropdownOpen) return;
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [dropdownOpen]);

    const reloadTable = () => {
        $('#user').DataTable().ajax.reload(null, false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        setStateReady(true);

        let data = {
            username: $("#username").val(),
            first_name: $("#first_name").val(),
            last_name: $("#last_name").val(),
            password: $("#password").val(),
            email: $("#email").val(),
            phone_number: $("#mobile_number").val(),
            job_title: "admin",
            is_superuser: $("#role").val() !== "admin"
        }

        if(editForm === true) {
            const removeKey = (key, {[key]: _, ...rest}) => rest;
            console.log(editId);
            actionAdmin("patch", editId, removeKey('password', data)).then((response) => {
                setStateReady(false);
                if(response.error) return toast.error("Something went wrong...", {position: "top-right"});
                onCloseModal("modalUser", "admin_form");
                $('#access').DataTable().ajax.reload();
                return toast.success("User account successfully created.", {position: "top-right"});
            });

            return false;
        }

        registerAdmin(data).then((response) => {
            setStateReady(false);
            if(response.error) return toast.error("Something went wrong...", {position: "top-right"});
            onCloseModal("modalUser", "admin_form");
            $('#access').DataTable().ajax.reload();
            return toast.success("User account successfully created.", {position: "top-right"});
        })
    }

    const onCloseModal = (id, form) => {
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        const modalEl = document.getElementById(id);
        if (modalEl && typeof window.bootstrap !== 'undefined') {
            const modal = window.bootstrap.Modal.getInstance(modalEl);
            if (modal) modal.hide();
        }
        $(`#${form}`).parsley().reset();
        document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
    };

    const handleRoleChange = (data) => {
        setSelectedRole({name: data.name, value: data.value});
        userRole = data.value;
        setDropdownOpen(false);
        reloadTable();
    };

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        const modalEl = document.getElementById(id);
        if (modalEl && typeof window.bootstrap !== 'undefined') {
            const modal = window.bootstrap.Modal.getInstance(modalEl);
            if (modal) modal.hide();
        }
        parsley.reset();
        parsley.destroy();
        document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
    };

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><a href="#">Menu</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Users</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Users</h4>
                    </div>
                    <div className="dropdown" ref={dropdownRef}>
                        <button
                            className="btn btn-sm btn-secondary dropdown-toggle"
                            type="button"
                            id="userRoleDropdown"
                            aria-haspopup="true"
                            aria-expanded={dropdownOpen}
                            onClick={(e) => {
                                e.stopPropagation();
                                setDropdownOpen((prev) => !prev);
                            }}
                        >
                            {selectedRole.name}
                        </button>
                        <div
                            className={`dropdown-menu tx-13 ${dropdownOpen ? 'show' : ''}`}
                            aria-labelledby="userRoleDropdown"
                        >
                            <button
                                type="button"
                                className={`dropdown-item ${selectedRole.value === 'all' ? 'active' : ''}`}
                                onClick={() => handleRoleChange({ name: 'All Users', value: 'all' })}
                            >
                                All Users
                            </button>
                            {roles.map((r, i) => (
                                <button
                                    key={i}
                                    type="button"
                                    className={`dropdown-item ${selectedRole.value === r.value ? 'active' : ''}`}
                                    onClick={() => handleRoleChange(r)}
                                >
                                    {r.name}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Users</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable.bind()} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="user" className="table table-hover">
                                    <thead>
                                    <tr>
                                        <th className="wd-20p">Username</th>
                                        <th className="wd-20p">Full Name</th>
                                        <th className="wd-20p">Email</th>
                                        <th className="wd-20p">Role</th>
                                        <th className="wd-20p">Action</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalUser" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-bs-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </a>
                                <div className="media-body"><a href="" role="button" className="close pos-absolute t-15 r-15" data-bs-dismiss="modal" onClick={resetForm.bind(null, "modalUser", "user_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">{editForm ? "Edit User" : "Create User"}</h4><p className="tx-13 tx-color-02 mg-b-0">{editForm ? "Edit" : "Create"} user to have access to the console/app</p></div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="user_form" className="parsley-style-1" onSubmit={handleSubmit.bind()}>
                                    <div id="usernameWrapper" className="form-group parsley-input">
                                        <label>Username<span className="tx-danger">*</span></label>
                                        <input id="username" type="text" className="form-control"
                                               placeholder="Enter username"
                                               autoComplete="none"
                                               data-parsley-class-handler="#usernameWrapper" required/>
                                    </div>
                                    <div id="fnameWrapper" className="form-group parsley-input">
                                        <label>First Name<span className="tx-danger">*</span></label>
                                        <input id="first_name" type="text" className="form-control"
                                               placeholder="Enter first name"
                                               autoComplete="none"
                                               data-parsley-class-handler="#fnameWrapper" required/>
                                    </div>

                                    <div id="lnameWrapper" className="form-group parsley-input">
                                        <label>Last Name<span className="tx-danger">*</span></label>
                                        <input id="last_name" type="text" className="form-control"
                                               placeholder="Enter last name"
                                               autoComplete="none"
                                               data-parsley-class-handler="#lnameWrapper" required/>
                                    </div>

                                    <div id="emailWrapper" className="form-group parsley-input">
                                        <label>Email Address<span className="tx-danger">*</span></label>
                                        <input id="email" type="text" className="form-control"
                                               placeholder="Enter email address"
                                               autoComplete="none"
                                               data-parsley-class-handler="#emailWrapper" required/>
                                    </div>

                                    <div id="mobileWrapper" className="form-group parsley-input">
                                        <label>Mobile Number<span className="tx-danger">*</span></label>
                                        <input id="mobile_number" type="text" className="form-control"
                                               placeholder="Enter Mobile Number"
                                               autoComplete="none"
                                               data-parsley-class-handler="#mobileWrapper" required/>
                                    </div>

                                    <div id="passwordWrapper" className="form-group parsley-input">
                                        <label>Password<span className="tx-danger">*</span></label>
                                        <input id="password" type="password" className="form-control"
                                               placeholder="Enter new password"
                                               autoComplete="none"
                                               data-parsley-class-handler="#passwordWrapper"/>
                                    </div>

                                    <div id="typeWrapper" className="form-group parsley-input">
                                        <label>Role <span className="tx-danger">*</span></label>
                                        <select className="custom-select" id="role" required defaultValue="">
                                            <option value="" disabled>Select</option>
                                            <option value="company-rep">Company Representatives</option>
                                            <option value="agent">Agent</option>
                                            <option value="farmer">Farmer</option>
                                            <option value="agronomist">Agronomist</option>
                                            <option value="agro-dealer">Agro-Dealer</option>
                                        </select>
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-success btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : editForm ? <button className="btn btn-success btn-block">Update Account</button> : <button className="btn btn-success btn-block">Create Account</button>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
};

export default User;
